export class ChartsUtils {

    static getChartColors() {
        return [
            { // first color
                backgroundColor: '#05384F',
                borderColor: 'rgba(225,10,24,0.2)',
                pointBackgroundColor: 'rgba(225,10,24,0.2)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(225,10,24,0.2)'
            },
            { // second color
                backgroundColor: '#00677E',
                borderColor: 'rgba(225,10,24,0.2)',
                pointBackgroundColor: 'rgba(225,10,24,0.2)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(225,10,24,0.2)'
            }]
    }

    static getPackageRatioChartOptions() {

        return {
            scaleShowVerticalLines: false,
            responsive: true,
            legend: { position: 'bottom' },
            options:{
                scales: {
                    x: [{
                        stacked: true,
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }],
                    y: [{
                        stacked: true,
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }]
                }
            }


        }


    }

    static getLineChartOptions() {
        return {
            scaleShowVerticalLines: false,
            responsive: true,
            legend: { position: 'bottom' },
            options:{
                scales: {
                    xAxes: [{
                        stacked: true,
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }],
                    yAxes: [{
                        stacked: true,
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }]
                },
            },
            // animation: {
            //     onComplete: function () {
            //         let chartInstance = this.chart,
            //             ctx = chartInstance.ctx;
            //         ctx.textAlign = 'center';
            //         ctx.textBaseline = 'bottom';
            //         this.data.datasets.forEach(function (dataset, i) {
            //             let meta = chartInstance.controller.getDatasetMeta(i);
            //             meta.data.forEach(function (bar, index) {
            //                 let data = dataset.data[index];
            //                 ctx.fillStyle = 'white'
            //                 // ctx.fillText(data, bar._model.x, bar._model.y);
            //                 ctx.fillText(data, bar._model.x - 15, bar._model.y + 8);
            //             });
            //         });
            //     }
            // }
        }
    }
    static getLineChartOptionsCustomize() {
        return {
            scaleShowVerticalLines: false,
            maintainAspectRatio: false,
            legend: { position: 'bottom' },
            options:{
                scales: {
                    xAxes: [{
                        stacked: true,
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }],
                    yAxes: [{
                        stacked: true,
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }]
                }
            }


        }
    }


    static getSetofSingleColor() {
        return [{ backgroundColor: ['#05384F', '#05384F', '#05384F'] }]
    }

    static getChartTypeBar() {
        return 'bar'
    }

    static getChartTypeHorizontalBar() {
        return 'horizontalBar'
    }

    static getBarChartLegend() {
        return true
    }

    static getStatusActiveInProgressUnderReviewOption() {
        return {
            scaleShowVerticalLines: false,
            maintainAspectRatio: false,
            legend: { position: 'bottom' },
            options:{
                scales: {
                    xAxes: [{
                        ticks: {
                            fontSize: 10
                        },
                        stacked: true,
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }],
                    yAxes: [{
                        stacked: true,
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }]
                }
            }
        }
    }

    static getActiveInProgressUnderReviewColor() {
        return [{ backgroundColor: ['#7D7D7D', '#7D7D7D', '#7D7D7D'] }]
    }

    static getActiveInProgressUnderReviewLabel() {
        return ['No. Pkg Data', 'InProgress', 'UnderReview'];
    }

    static getStandardNonStandardLable() {
        return ['TTL', 'Fuso Paid', 'Supplier Paid'];
    }

    static getStandardNonStandardPackageCodeColor() {
        return [{ backgroundColor: ['#7D7D7D', '#05384F', '#00677E'] }]
    }

    static getStatusActiveInProgressUnderReviewPackageCodeOption() {
        return {
            scaleShowVerticalLines: false,
            legend: { position: 'bottom' },
            title: {
                display: true,
                fontColor: '#B6B6B6',
                text: 'Packaging Codes',
                position: 'bottom'
            },
            options:{
                scales: {
                    xAxes: [{
                        stacked: true,
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }],
                    yAxes: [{
                        stacked: true,
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }]
                }
            },
            // animation: {
            //     onComplete: function () {
            //         let chartInstance = this.chart,
            //             ctx = chartInstance.ctx;
            //         ctx.textAlign = 'center';
            //         ctx.textBaseline = 'bottom';
            //         this.data.datasets.forEach(function (dataset, i) {
            //             let meta = chartInstance.controller.getDatasetMeta(i);
            //             meta.data.forEach(function (bar, index) {
            //                 let data = dataset.data[index];
            //                 ctx.fillStyle = 'white'
            //                 // ctx.fillText(data, bar._model.x, bar._model.y);
            //                 ctx.fillText(data, bar._model.x - 15, bar._model.y + 8);
            //             });
            //         });
            //     }
            // }

        }
    }

    static getStatusActiveInProgressUnderReviewPackageCodeLabel() {
        return ['TTL', 'Standard', 'Non Standard']
    }

    static getStatusActiveInProgressUnderReviewOptionWitnPercentage() {
        return {
            scaleShowVerticalLines: false,
            maintainAspectRatio: false,
            legend: { position: 'bottom' },
           options:{
            scales: {
                xAxes: [{
                    ticks: {
                        fontSize: 10
                    },
                    stacked: true,
                    gridLines: {
                        drawOnChartArea: false
                    }
                }],
                yAxes: [{
                    stacked: true,
                    gridLines: {
                        drawOnChartArea: false
                    }
                }]
            }
           },
            // animation: {
            //     onComplete: function () {
            //         let chartInstance = this.chart,
            //             ctx = chartInstance.ctx;
            //         ctx.textAlign = 'center';
            //         ctx.textBaseline = 'bottom';
            //         this.data.datasets.forEach(function (dataset, i) {
            //             let meta = chartInstance.controller.getDatasetMeta(i);
            //             meta.data.forEach(function (bar, index) {
            //                 let data = dataset.data[index];
            //                 ctx.fillStyle = 'white'
            //                 // ctx.fillText(data, bar._model.x, bar._model.y);
            //                 // ctx.fillText(data +'%', bar._model.x - 1, bar._model.y + 14);
            //                 ctx.fillText(data, bar._model.x - 1, bar._model.y + 25);
            //             });
            //         });
            //     }
            // }
        }
    }

    static getDailyPoChartOption(){
        return {
            scaleShowVerticalLines: false,
            responsive: true,
            legend: { position: 'bottom' },
            options:{
                scales: {
                    xAxes: [{
                        stacked: true,
                        gridLines: {
                            drawOnChartArea: false
                        },
                    }],
                    yAxes: [{
                        stacked: true,
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }]
                }
            },
            // animation: {
            //     onComplete: function () {
            //         let chartInstance = this.chart,
            //             ctx = chartInstance.ctx;
            //         ctx.textAlign = 'center';
            //         ctx.textBaseline = 'bottom';
            //         this.data.datasets.forEach(function (dataset, i) {
            //             let meta = chartInstance.controller.getDatasetMeta(i);
            //             meta.data.forEach(function (bar, index) {
            //                 let data = dataset.data[index];
            //                 ctx.fillStyle = 'white'
            //                 ctx.fillText(data, bar._model.x, bar._model.y+17);
            //             });
            //         });
            //     }
            // }
          }
    }

    static getDailyPoChartLabel() {
        return ['Day 1','Day 2', 'Day 3', 'Day 4', 'Day 5', 'Day 6', 'Day 7', 'Day 8', 'Day 9', 'Day 10', 'Day 11', 'Day 12', 'Day 13', 'Day 14', 'Day 15', 'Day 16', 'Day 17', 'Day 18', 'Day 19', 'Day 20'];
    }

    static getDailyPoChartColors() {
        return [
            {
              // First
              backgroundColor: "#004355",
              borderColor: "rgba(148,159,177,1)",
              pointBackgroundColor: "rgba(148,159,177,1)",
              pointBorderColor: "#fff",
              pointHoverBackgroundColor: "#fff",
              pointHoverBorderColor: "rgba(148,159,177,0.8)"
            },
            {
              // Second
              backgroundColor: "#00677E",
              borderColor: "rgba(77,83,96,1)",
              pointBackgroundColor: "rgba(77,83,96,1)",
              pointBorderColor: "#fff",
              pointHoverBackgroundColor: "#fff",
              pointHoverBorderColor: "rgba(77,83,96,1)"
            },
            {
              // Third
              backgroundColor: "#007892",
              borderColor: "rgba(148,159,177,1)",
              pointBackgroundColor: "rgba(148,159,177,1)",
              pointBorderColor: "#fff",
              pointHoverBackgroundColor: "#fff",
              pointHoverBorderColor: "rgba(148,159,177,0.8)"
            },
            {
              // Fourth
              backgroundColor: "#0787A5",
              borderColor: "rgba(148,159,177,1)",
              pointBackgroundColor: "rgba(148,159,177,1)",
              pointBorderColor: "#fff",
              pointHoverBackgroundColor: "#fff",
              pointHoverBorderColor: "rgba(148,159,177,0.8)"
            },
            {
              // Fifth Top
              backgroundColor: "#A7C9D8",
              borderColor: "rgba(148,159,177,1)",
              pointBackgroundColor: "rgba(148,159,177,1)",
              pointBorderColor: "#fff",
              pointHoverBackgroundColor: "#fff",
              pointHoverBorderColor: "rgba(148,159,177,0.8)"
            }
          ]
    }

}

